import { graphql } from "react-relay";

import "./web-app-nav-avatar-menu/WebAppNavAvatarMenu.gql";

export const webAppNavFragments = {
  viewer: graphql`
    fragment WebAppNav_viewer on Viewer {
      ...WebAppNavAvatarMenu_viewer
    }
  `,
};
